export default __webpack_public_path__ + "static/media/bg.fe64960d.jpg";